import { BaseController } from "./baseController";

export interface ReferenceValue {
    value: string;
    title: string;
}

interface ReferencesQueryResponse {
    data: {
        references: ReferenceValue[];
    };
}

export class ReferencesController extends BaseController {
    async getReferences(referenceFieldName: string, locale: string): Promise<ReferenceValue[]> {
        const query = `{references(name:"${referenceFieldName}", language: "${locale}"){value,title}}`;
        const response = await this.get<ReferencesQueryResponse>(`${this.apiHost}?query=${encodeURIComponent(query)}`);
        return response?.data?.references || [];
    }
}
